// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"578":"b6dbff94","667":"d998fb88","977":"4df8716f"}[chunkId] + ".chunk.js";
};